import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fa-duotone fa-tags" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_form_item = _resolveComponent("n-form-item")!

  return (_openBlock(), _createBlock(_component_n_form_item, {
    rule: {
      required: $props.required,
      message: $props.message,
      trigger: ['blur', 'change', 'update'],
    },
    label: $props.label,
    class: _normalizeClass('col-md-' + $props.col + '  mb-' + $props.mb),
    path: $props.path,
    isRtl: true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_select, {
        value: $setup.MyValue,
        "onUpdate:value": [
          _cache[0] || (_cache[0] = ($event: any) => (($setup.MyValue) = $event)),
          $setup.UpdateValue
        ],
        options: $props.options,
        disabled: $props.disabled,
        placeholder: $props.placeholder,
        size: _ctx.formSetting.formSize,
        clearable: "",
        filterable: "",
        multiple: $props.multiple,
        tag: "",
        "max-tag-count": $props.max
      }, {
        arrow: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["value", "options", "disabled", "placeholder", "size", "multiple", "onUpdate:value", "max-tag-count"])
    ]),
    _: 1
  }, 8, ["rule", "label", "class", "path"]))
}